import { OrderStatus } from "../../@core/constants/OrderStatus.constant";

export const BadgeOrder = ({ status }: { status }) => {
  return (
    <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${OrderStatus[status]?.className}`}>
      {OrderStatus[status]?.label || "Unknown"}
    </span>
  );
}
